import { useAppDispatch, useAppStore } from "@hooks/redux";
import { useTiktokShopAuth } from "@hooks/useTiktokShopAuth";
import { useSerializeCallback } from "@kalodata/tools";
import { fetchLinkedAccounts, selectTiktokLinkedAccounts } from "@store/linkedAccountSlice";
import { TiktokShopAuthCode } from "@type/tiktokShopAuth";
import { message } from "antd";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";

export function useLinkAccount() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const store = useAppStore();
  const openTikTokAuth = useTiktokShopAuth();

  // toast + 按需跳转，不负责拉数据，由调用方决定何时 fetch
  const notifyConnected = () => {
    message.success(t("Account connected successfully!"));
    const url = new URL(window.location.href);
    if (url.pathname === "/me" && url.searchParams.get("tab") === "linkedAccounts") {
      navigate("/library?type=video");
    }
  };

  return useSerializeCallback(async () => {
    const beforeIds = new Set(
      selectTiktokLinkedAccounts(store.getState())
        .map((a) => a.id)
        .filter((id): id is number => id !== undefined),
    );

    const result = await openTikTokAuth();

    if (result.code === TiktokShopAuthCode.Ok) {
      await dispatch(fetchLinkedAccounts());
      notifyConnected();
      return;
    }

    if (result.code === TiktokShopAuthCode.UserClosed) {
      // 后端可能已绑定但回调页 BroadcastChannel 没来得及发消息（扫码后立刻关弹窗）
      await dispatch(fetchLinkedAccounts());
      const hasNewBinding = selectTiktokLinkedAccounts(store.getState()).some(
        (a) => a.id !== undefined && !beforeIds.has(a.id),
      );
      if (hasNewBinding) {
        notifyConnected();
        return;
      }
      message.error(result.msg || t("Failed to connect account. Please try again."));
      return;
    }
    message.error(result.msg || t("Failed to connect account. Please try again."));
    await dispatch(fetchLinkedAccounts());
  });
}
